<template>
  <v-tabs
    v-model="currentTab"
    align-tabs="start"
    class="smaller-tabs"
    color="#0F6DAC"
    density="compact"
    slider-color="primary">
    <v-tab
      v-for="tab in tabs"
      :key="tab.value"
      class="text-none text-caption"
      :class="{
        'error':
          spaceStore.fieldStatus.tab[nodeId + '|' + tab.value] === 'error'
      }"
      :prepend-icon="tab.icon"
      :value="tab.value"
      variant="text"
      :data-cy="`${tab.value}-tab`">
      {{ t(`entities.${elementType}.tabs.${tab.value}`) }}
    </v-tab>
  </v-tabs>
  <v-window v-model="currentTab">
    <v-window-item
      v-for="tab in tabs"
      :key="tab.value"
      :value="tab.value">
      <v-container
        fluid
        :style="tab.containerStyle">
        <component
          :key="nodeId"
          :is="tab.component"
          :node-id="nodeId" />
      </v-container>
    </v-window-item>
  </v-window>
</template>

<script setup lang="ts">
import { useTranslation } from "i18next-vue";
import { ref } from "vue";
const { t } = useTranslation();

import { useTreeStore } from "@/stores/treeStore";
import { useMainStore } from "@/stores/mainStore";
import { useSpaceStore } from "@/stores/spaceStore";

const {
  defaultTab = "basicData",
  tabs,
  nodeId,
  name
} = defineProps<{
  tabs: {
    value: string;
    icon: string;
    component: any;
    containerStyle?: string;
  }[];
  nodeId: string;
  defaultTab?: string;
  name: string;
}>();

const nodeType = nodeId.split("_")[1];
const elementType = name ?? nodeType;

const treeStore = useTreeStore();
const mainStore = useMainStore();
const spaceStore = useSpaceStore();

const currentTab = ref(defaultTab);
</script>
<style scoped>
.error {
  color: red !important;
}
</style>
